'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m10.093 18-1.454-3.415c1.4-.517 2.71-1.212 3.923-2.023L10.092 18ZM3.415 9.361 0 7.908l5.439-2.47a18.764 18.764 0 0 0-2.024 3.923Zm12.107-7.578c.25 0 .473 0 .66.045.152 1.239-.018 3.789-2.942 6.713a15.098 15.098 0 0 1-5.358 3.468l-1.917-1.872c.82-2.06 1.988-3.87 3.495-5.376 2.46-2.46 4.654-2.978 6.062-2.978Zm0-1.783c-1.765 0-4.44.615-7.328 3.504-1.953 1.952-3.12 4.1-3.879 5.982a1.8 1.8 0 0 0 .41 1.899l1.9 1.89c.338.339.793.544 1.265.544.206 0 .42-.054.625-.134a17.03 17.03 0 0 0 5.982-3.878c5.046-5.046 3.156-9.46 3.156-9.46S16.842 0 15.523 0ZM11.35 6.65a1.786 1.786 0 0 1 0-2.522 1.787 1.787 0 0 1 2.523 0 1.795 1.795 0 0 1 0 2.523 1.787 1.787 0 0 1-2.523 0Zm-7.4 11.18 3.245-3.245a2.722 2.722 0 0 1-.865-.4L2.693 17.83H3.95Zm-3.78 0h1.257l4.252-4.243-1.266-1.257L.17 16.574v1.257Zm0-2.522 3.646-3.638a2.636 2.636 0 0 1-.401-.865L.169 14.05v1.258Z",
    fill: "currentColor"
  }));
});
var Rocket = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Rocket = Rocket;